<template>
  <picture
    class="feature-image"
    :style="cssVars"
  >
    <source
      :srcset="smSrcSet"
      :media="`(max-width: ${toCssSize(thresholds.md - 1)})`"
    />

    <source
      :srcset="srcSet || src"
      :media="`(min-width: ${toCssSize(thresholds.md)})`"
    />

    <img
      loading="lazy"
      :src="src"
      :alt="alt"
    />
  </picture>
</template>

<script setup lang="ts">
import { useDisplay } from 'vuetify'

type Props = {
  maxHeight?: number | string
  height?: number | string
  smHeight?: number | string
  smMaxHeight?: number | string
  width?: number | string
  maxWidth?: number | string
  smWidth?: number | string
  smMaxWidth?: number | string
  src: string
  srcSet?: string
  smSrcSet: string
  alt: string
}

const props = withDefaults(defineProps<Props>(), {
  width: 'auto',
  smWidth: 'auto',
  height: 'auto',
  smHeight: 'auto',
  srcSet: '',
  maxHeight: 'none',
  smMaxHeight: 'none',
  maxWidth: 'none',
  smMaxWidth: 'none',
})

const { thresholds } = useDisplay()

const cssVars = computed(() => ({
  ['--height']: toCssSize(props.height),
  ['--max-height']: toCssSize(props.maxHeight),
  ['--sm-height']: toCssSize(props.smHeight),
  ['--sm-max-height']: toCssSize(props.smMaxHeight),
  ['--width']: toCssSize(props.width),
  ['--max-width']: toCssSize(props.maxWidth),
  ['--sm-width']: toCssSize(props.smWidth),
  ['--sm-max-width']: toCssSize(props.smMaxWidth),
}))
</script>
